module.exports = __webpack_public_path__ + "static/media/laptop.441dd6f2.png";